module.exports = __webpack_public_path__ + "img/check.beaa72a8.svg";